// packages/components/src/LanguageSwitcher.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@dopomogai/ui';

const supportedLanguages = [
  { code: 'en', name: 'EN' },
  { code: 'uk', name: 'UA' },
];

export const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const currentLangIndex = supportedLanguages.findIndex(l => i18n.language.startsWith(l.code));
  const nextLang = supportedLanguages[(currentLangIndex + 1) % supportedLanguages.length];

  return (
    <Button
      variant="ghost"
      onClick={() => changeLanguage(nextLang.code)}
      aria-label={`Switch to ${nextLang.name}`}
      title={`Switch to ${nextLang.name}`}
      // --- THE FIX: Explicitly set the text color so it's not transparent by default ---
      className="text-slate-600 hover:text-sky-500 font-semibold"
    >
      <span className="text-sm">
        {supportedLanguages[currentLangIndex]?.name || 'EN'}
      </span>
    </Button>
  );
};